import {
  EventContainer,
  PageHeaderControl,
  UserProfile
} from '@seims/shared'

export const UpdatePasswordView = () => {
  return (
    <PageHeaderControl title="Update Password" showConfirmBack >
      <EventContainer>
        <UserProfile />
      </EventContainer>
    </PageHeaderControl>
  )
}
